module.exports = __webpack_public_path__ + "static/media/jen_luker.6a243b10.jpg";